// src/components/LoginSignupLayout.tsx
import React from 'react';

interface LoginSignupLayoutProps {
  children: React.ReactNode;
  currentUserType: 'buyer' | 'seller';
  onUserTypeChange: (type: 'buyer' | 'seller') => void;
}

const LoginSignupLayout: React.FC<LoginSignupLayoutProps> = ({ children, currentUserType, onUserTypeChange }) => {
  return (
    // FIX: Added 'max-w-[350px] md:max-w-full' for better mobile centering
    <div className="w-full flex flex-col items-center max-w-[360px] md:max-w-full mx-auto">
       
       {/* --- CARD / OUTLINE CONTAINER --- */}
       {/* Ye 'bg-white', 'border', aur 'shadow' form ko ek box mein pack karega */}
       <div className="w-full bg-white border border-gray-200 rounded-3xl shadow-[0_10px_40px_-10px_rgba(0,0,0,0.1)] overflow-hidden">
           
           {/* Toggle Switch inside the Card Header */}
           <div className="bg-gray-50/50 p-6 pb-2 border-b border-gray-100 flex justify-center">
              <div className="inline-flex bg-gray-200/60 p-1 rounded-xl relative w-full max-w-[280px]">
                 {/* Slider Animation */}
                 <div 
                    className={`absolute top-1 bottom-1 w-[calc(50%-4px)] bg-white rounded-lg shadow-sm transform transition-transform duration-500 ease-[cubic-bezier(0.68,-0.55,0.27,1.55)] ${currentUserType === 'seller' ? 'translate-x-full left-1' : 'left-1'}`}
                 ></div>

                 <button
                    onClick={() => onUserTypeChange('buyer')}
                    className={`relative z-10 w-1/2 py-2.5 text-xs sm:text-sm font-bold rounded-lg transition-colors duration-300 ${currentUserType === 'buyer' ? 'text-emerald-700' : 'text-gray-500 hover:text-gray-700'}`}
                 >
                    Buyer
                 </button>
                 <button
                    onClick={() => onUserTypeChange('seller')}
                    className={`relative z-10 w-1/2 py-2.5 text-xs sm:text-sm font-bold rounded-lg transition-colors duration-300 ${currentUserType === 'seller' ? 'text-emerald-700' : 'text-gray-500 hover:text-gray-700'}`}
                 >
                    Seller
                 </button>
              </div>
           </div>

           {/* Form Content Area */}
           <div className="p-6 md:p-8">
               {children}
           </div>
       </div>

    </div>
  );
};

export default LoginSignupLayout;